import { mergeStyles } from '@cian/components';
import * as React from 'react';

import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { TenantsType } from '../../store/offer/index';
import * as styles from './index.css';

export interface ITenantsProps {
  offer: IOfferSchema;
}

const tenantsTypeText = {
  [TenantsType.Any]: 'Любой состав съёмщиков',
  [TenantsType.Family]: 'Для семьи',
  [TenantsType.Female]: 'Для женщины',
  [TenantsType.Male]: 'Для мужчины',
};

export class Tenants extends React.PureComponent<ITenantsProps, {}> {
  public render() {
    const { offer } = this.props;

    if (!offer.childrenAllowed && !offer.petsAllowed && !offer.bargainTerms.tenantsType) {
      return null;
    }

    return (
      <ul className={styles['container']}>
        {offer.childrenAllowed && <li {...mergeStyles([styles['item'], styles['kids']])}>Можно с детьми</li>}
        {offer.petsAllowed && <li {...mergeStyles([styles['item'], styles['pets']])}>Можно с животными</li>}
        {offer.bargainTerms && offer.bargainTerms.tenantsType && tenantsTypeText[offer.bargainTerms.tenantsType] && (
          <li {...mergeStyles([styles['item'], styles['tenant']])}>
            {tenantsTypeText[offer.bargainTerms.tenantsType]}
          </li>
        )}
      </ul>
    );
  }
}
